import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { MARK_ALERT_READ_FAILED, MARK_ALERT_READ_SUCCESS } from '../../helpers/messages';
import { readAlertsAPI } from '../../services/alerts';
import { useThemeMode } from '../../components/theme';


const ReadAlertConfirmComponent = ({ selected, onSuccess, markAll = false, unreadCounts }) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();
    const { FONT } = useThemeMode();

    // This function will be called when the confirm button is clicked
    const onConfirm = async () => {
        try {
            setIsLoading(true)
            await readAlertsAPI({ readAlertIds: selected });
            setOpen(false);
            setIsLoading(false);
            onSuccess();
            showSnackbar(MARK_ALERT_READ_SUCCESS);
        } catch (error) {
            console.error("Error: ", error);
            setIsLoading(false)
            showSnackbar(error.message || MARK_ALERT_READ_FAILED, "error");
        }
    };

    // This function will render the confirm dialog
    const renderConfirm = () => {
        return (<ConfirmDialog
            open={open}
            loading={isLoading}
            onClose={() => setOpen(false)}
            onConfirm={onConfirm}
            title="Confirm Mark as Read"
            okText="Okay"
            message={
                markAll ? `You are about to mark all alerts as read. Do you wish to proceed?` : `You are about to mark the selected alert${selected.length > 1 ? "s" : ""} as read. Do you wish to proceed?`
            }
        />)
    }

    // This function will be called when the button is clicked
    // It will set the open state to true, which will open the confirm dialog
    const handleClick = (e) => {
        setOpen(true);
    }

    return (
        <>
            {renderConfirm()}
            {markAll ? <Button
                size="small"
                variant="text"
                sx={{ fontSize: FONT.SIZE_16, fontWeight: 600 }}
                onClick={handleClick}
                disabled={unreadCounts === 0}
            >
                Mark All as Read
            </Button> : <Button
                variant="outlined"
                disabled={unreadCounts === 0}
                onClick={handleClick}
            >
                Mark as Read
            </Button>}
        </>
    )
}

// define prop types for the component
ReadAlertConfirmComponent.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSuccess: PropTypes.func.isRequired,
    markAll: PropTypes.bool,
    unreadCounts: PropTypes.number.isRequired,
};
export default ReadAlertConfirmComponent